// extracted by mini-css-extract-plugin
export default {"airlineTableOuter":"airlines_airlineTableOuter__k3iJF","checkboxWrapper":"airlines_checkboxWrapper__0SgiD","tableTextField":"airlines_tableTextField__qnEYg"};